import { ReactNode } from 'react';

import {
  DrawerHeader,
  ShadowDivider,
  Typography,
  Stack,
  tokens,
} from '@cast/design-system';

type DrawerSplitLayoutProps = {
  header: string;
  title: string;
  titleAction?: ReactNode;
  renderLeftSide(): ReactNode;
  renderRightSide(): ReactNode;
};

export function DrawerSplitLayout({
  header,
  title,
  titleAction,
  renderLeftSide,
  renderRightSide,
}: DrawerSplitLayoutProps) {
  return (
    <Stack height="100%" direction="row">
      <Stack flex="0 0 33.333%" position="relative" overflow="auto">
        <DrawerHeader direction="column" alignItems="flex-start" gap={8}>
          <Stack mt={8}>
            <Typography
              variant="L12R"
              color={tokens.theme.fg.structural.secondary}
            >
              {header}
            </Typography>
            <Stack direction="row" alignItems="center" gap={8}>
              <Typography variant="h4">{title}</Typography>
              {titleAction}
            </Stack>
          </Stack>
        </DrawerHeader>

        {renderLeftSide()}

        <ShadowDivider
          orientation="vertical"
          direction="left"
          top
          right
          size={16}
          opacity={0.2}
          absolute
        />
      </Stack>

      <Stack flex="1 1 66.667%" overflow="hidden" position="relative">
        {renderRightSide()}
      </Stack>
    </Stack>
  );
}
